import { j as ae } from "./jsx-runtime-B6kdoens.js";
import { cloneElement as ie } from "react";
import { a as h } from "./index-CROKJrb5.js";
import { c as ce, f as fe } from "./create-component-CBAeEoQ6.js";
var P = { exports: {} }, t = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var I;
function ue() {
  if (I) return t;
  I = 1;
  var E = Symbol.for("react.element"), i = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), s = Symbol.for("react.context"), S = Symbol.for("react.server_context"), m = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), b;
  b = Symbol.for("react.module.reference");
  function a(e) {
    if (typeof e == "object" && e !== null) {
      var _ = e.$$typeof;
      switch (_) {
        case E:
          switch (e = e.type, e) {
            case n:
            case l:
            case u:
            case d:
            case p:
              return e;
            default:
              switch (e = e && e.$$typeof, e) {
                case S:
                case s:
                case m:
                case y:
                case v:
                case c:
                  return e;
                default:
                  return _;
              }
          }
        case i:
          return _;
      }
    }
  }
  return t.ContextConsumer = s, t.ContextProvider = c, t.Element = E, t.ForwardRef = m, t.Fragment = n, t.Lazy = y, t.Memo = v, t.Portal = i, t.Profiler = l, t.StrictMode = u, t.Suspense = d, t.SuspenseList = p, t.isAsyncMode = function() {
    return !1;
  }, t.isConcurrentMode = function() {
    return !1;
  }, t.isContextConsumer = function(e) {
    return a(e) === s;
  }, t.isContextProvider = function(e) {
    return a(e) === c;
  }, t.isElement = function(e) {
    return typeof e == "object" && e !== null && e.$$typeof === E;
  }, t.isForwardRef = function(e) {
    return a(e) === m;
  }, t.isFragment = function(e) {
    return a(e) === n;
  }, t.isLazy = function(e) {
    return a(e) === y;
  }, t.isMemo = function(e) {
    return a(e) === v;
  }, t.isPortal = function(e) {
    return a(e) === i;
  }, t.isProfiler = function(e) {
    return a(e) === l;
  }, t.isStrictMode = function(e) {
    return a(e) === u;
  }, t.isSuspense = function(e) {
    return a(e) === d;
  }, t.isSuspenseList = function(e) {
    return a(e) === p;
  }, t.isValidElementType = function(e) {
    return typeof e == "string" || typeof e == "function" || e === n || e === l || e === u || e === d || e === p || e === T || typeof e == "object" && e !== null && (e.$$typeof === y || e.$$typeof === v || e.$$typeof === c || e.$$typeof === s || e.$$typeof === m || e.$$typeof === b || e.getModuleId !== void 0);
  }, t.typeOf = a, t;
}
var o = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g;
function le() {
  return g || (g = 1, process.env.NODE_ENV !== "production" && function() {
    var E = Symbol.for("react.element"), i = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), s = Symbol.for("react.context"), S = Symbol.for("react.server_context"), m = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), b = !1, a = !1, e = !1, _ = !1, w = !1, $;
    $ = Symbol.for("react.module.reference");
    function F(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === n || r === l || w || r === u || r === d || r === p || _ || r === T || b || a || e || typeof r == "object" && r !== null && (r.$$typeof === y || r.$$typeof === v || r.$$typeof === c || r.$$typeof === s || r.$$typeof === m || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === $ || r.getModuleId !== void 0));
    }
    function f(r) {
      if (typeof r == "object" && r !== null) {
        var C = r.$$typeof;
        switch (C) {
          case E:
            var R = r.type;
            switch (R) {
              case n:
              case l:
              case u:
              case d:
              case p:
                return R;
              default:
                var A = R && R.$$typeof;
                switch (A) {
                  case S:
                  case s:
                  case m:
                  case y:
                  case v:
                  case c:
                    return A;
                  default:
                    return C;
                }
            }
          case i:
            return C;
        }
      }
    }
    var L = s, N = c, O = E, Y = m, D = n, V = y, j = v, q = i, W = l, z = u, U = d, k = p, x = !1, M = !1;
    function B(r) {
      return x || (x = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function X(r) {
      return M || (M = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function G(r) {
      return f(r) === s;
    }
    function H(r) {
      return f(r) === c;
    }
    function Z(r) {
      return typeof r == "object" && r !== null && r.$$typeof === E;
    }
    function J(r) {
      return f(r) === m;
    }
    function K(r) {
      return f(r) === n;
    }
    function Q(r) {
      return f(r) === y;
    }
    function ee(r) {
      return f(r) === v;
    }
    function re(r) {
      return f(r) === i;
    }
    function te(r) {
      return f(r) === l;
    }
    function oe(r) {
      return f(r) === u;
    }
    function ne(r) {
      return f(r) === d;
    }
    function se(r) {
      return f(r) === p;
    }
    o.ContextConsumer = L, o.ContextProvider = N, o.Element = O, o.ForwardRef = Y, o.Fragment = D, o.Lazy = V, o.Memo = j, o.Portal = q, o.Profiler = W, o.StrictMode = z, o.Suspense = U, o.SuspenseList = k, o.isAsyncMode = B, o.isConcurrentMode = X, o.isContextConsumer = G, o.isContextProvider = H, o.isElement = Z, o.isForwardRef = J, o.isFragment = K, o.isLazy = Q, o.isMemo = ee, o.isPortal = re, o.isProfiler = te, o.isStrictMode = oe, o.isSuspense = ne, o.isSuspenseList = se, o.isValidElementType = F, o.typeOf = f;
  }()), o;
}
process.env.NODE_ENV === "production" ? P.exports = ue() : P.exports = le();
var me = P.exports;
const de = {
  xs: 12,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
  xxl: 64
}, Se = ce(
  "IconBase",
  fe(
    ({
      fillMethod: E,
      image: i,
      size: n = "md",
      className: u,
      ...l
    }, c) => {
      let s = null;
      typeof n == "number" ? s = n : typeof n == "string" && (s = de[n]);
      const S = {
        className: h(
          {
            "cur-fill-current": E === "path",
            "cur-text-inherit": E === "stroke"
          },
          u
        ),
        ...l,
        ...n === null ? {} : {
          height: s,
          width: s
        }
      };
      if (typeof i == "object" && i.$$typeof === me.Element) {
        const { className: m, ...d } = i.props;
        return ie(i, {
          ...d,
          ...S,
          className: h(m, S.className),
          size: n,
          ref: c
        });
      }
      return /* @__PURE__ */ ae.jsx(i, { ref: c, ...S });
    }
  )
);
export {
  Se as I,
  de as i
};
//# sourceMappingURL=IconBase-CxZyIWw2.js.map
